import { Directive, ElementRef, HostBinding, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[emptyCell]',
    standalone: true,
})
export class EmptyCellDirective implements OnChanges
{
    @Input() emptyCell: boolean;
    @Input() useZero: boolean;
    @Input() emptyCellText = '--';

    constructor(
            private _el: ElementRef,
            private _renderer: Renderer2,
    ) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.hasOwnProperty('emptyCell')) {
            if (this.emptyCell) {
                const emptyCell = this._renderer.createElement('span');
                emptyCell.textContent = this.useZero ? '0' : this.emptyCellText;
                emptyCell.classList.add('add-ashy-blue');

                this._el.nativeElement.textContent = '';
                this._renderer.appendChild(this._el.nativeElement, emptyCell);
            }
        }
    }
}

@Directive({
    selector: '[justifyRightCell]',
    standalone: true,
    host: { class: 'mat-column-justify-right' },
})
export class JustifyRightCellDirective
{
}

@Directive({
    selector: '[numberCell]',
    standalone: true,
    host: { class: 'mat-column-number' },
})
export class NumberCellDirective
{
}

@Directive({
    selector: '[appTable]',
    standalone: true,
    host: { class: 'app-table' },
})
export class AppTableDirective
{
}

@Directive({
    selector: '[appTableRow]',
    standalone: true,
    host: { class: 'app-table-row' },
})
export class AppTableRowDirective
{
    @Input() headerRow = false;
    @Input() workingRow = false;
    @Input() selectableRow = false;
    @Input() firstRow = false;

    @HostBinding('class.header-row') get addHeaderRowClass() {
        return this.headerRow;
    }
    @HostBinding('class.working-row') get addWorkingRowClass() {
        return this.workingRow;
    }
    @HostBinding('class.hover-row') get addHoverRowClass() {
        return this.selectableRow;
    }
    @HostBinding('class.first-row') get addFirstRowClass() {
        return this.firstRow;
    }
}
